<template>
    <section id="form_section">
        <div class="container">
            <div class="service_header">
                <h1 class="service_title">Пристрій плавного пуску</h1>
                <a href="javascript:void(0)" v-on:click="modal_info = true" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
            </div>

            <div class="top_bar">
                <p class="top_bar_title">Список конфігурацій</p>
                <a class="add_btn" href="javascript:void(0)" @click="openAddModal">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white"/>
                    </svg>
                    Додати плавний пуск
                </a>
            </div>

            <div class="main_table_container">
            <table class="main_table">
                <tr>
                    <th class="main_table_title">Автоматичний вимикач</th>
                    <th class="main_table_title">Запобіжник</th>
                    <th class="main_table_title">Тримач запобіжника</th>
                    <th class="main_table_title">Контактор</th>
                    <th class="main_table_title">Плавний пуск</th>
                    <th class="main_table_title">Вентилятор</th>
                    <th class="main_table_title">Плата живлення</th>
                    <th class="main_table_title">Шафа</th>
                    <th class="main_table_title"></th>
                </tr>
                <tr v-for="(item, i) in items" :key="`item_${i}`">
                    <td class="main_table_row" style="text-align: center;">
                        <select class="form_select table_select" v-model="item.automatic_switch" @change="selectListItem(i, item)">
                            <option :value="null">Відсутній</option>
                            <option v-for="(automatic_switch, i) in item.automatic_switches" :key="`value_${i}`" :value="automatic_switch">{{ automatic_switch.description ? automatic_switch.description : automatic_switch.name }}</option>
                        </select>
                    </td>
                    <td class="main_table_row" style="text-align: center;">
                        <select class="form_select table_select" v-model="item.fuse" @change="selectListItem(i, item)">
                            <option :value="null">Відсутній</option>
                            <option v-for="(fuse, i) in item.fuses" :key="`value_${i}`" :value="fuse">{{ fuse.description ? fuse.description : fuse.name }}</option>
                        </select>
                    </td>
                    <td class="main_table_row" style="text-align: center;">
                        <select class="form_select table_select" v-model="item.fuse_holder">
                            <option :value="null">Відсутній</option>
                            <option v-for="(fuse_holder, i) in item.fuse_holders" :key="`value_${i}`" :value="fuse_holder">{{ fuse_holder.description ? fuse_holder.description : fuse_holder.name }}</option>
                        </select>
                    </td>
                    <td class="main_table_row" style="text-align: center;">
                        <select class="form_select table_select" v-model="item.contactor" @change="selectListItem(i, item)">
                            <option :value="null">Відсутній</option>
                            <option v-for="(contactor, i) in item.contactors" :key="`value_${i}`" :value="contactor">{{ contactor.description ? contactor.description : contactor.name }}</option>
                        </select>
                    </td>
                    <td class="main_table_row" style="text-align: center;">{{ item.variants_soft_start.article }}</td>
                    <td class="main_table_row" style="text-align: center;">{{ item.fan ? item.fan.fan : '-' }}</td>
                    <td class="main_table_row" style="text-align: center;">{{ item.power_board ? item.power_board.control_voltage_article : '-' }}</td>
                    <td class="main_table_row" style="text-align: center;">
                        <select class="form_select table_select" v-model="item.metalconstruction" :disabled="completing_in_one_cabinet==='yes'">
                            <option :value="null">Відсутня</option>
                            <option v-for="(metalconstruction, i) in item.metalconstruction_products" :key="`value_${i}`" :value="metalconstruction">{{ metalconstruction.name }}</option>
                        </select>
                    </td>

                    <td class="main_table_row" style="text-align: center;">
                        <div class="edit_row">
                            <a href="javascript:void(0)" v-on:click="editProduct(i)" v-tooltip.bottom="'Редагувати'">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 15.2496V18.9996H3.75L14.81 7.93957L11.06 4.18957L0 15.2496ZM17.71 5.03957C18.1 4.64957 18.1 4.01957 17.71 3.62957L15.37 1.28957C14.98 0.89957 14.35 0.89957 13.96 1.28957L12.13 3.11957L15.88 6.86957L17.71 5.03957Z" fill="#356EEF"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" v-on:click="copyItem(i)" v-tooltip.bottom="'Скопіювати'">
                                <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 0H2C0.9 0 0 0.9 0 2V16H2V2H14V0ZM17 4H6C4.9 4 4 4.9 4 6V20C4 21.1 4.9 22 6 22H17C18.1 22 19 21.1 19 20V6C19 4.9 18.1 4 17 4ZM17 20H6V6H17V20Z" fill="#356EEF"/>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" v-on:click="deleteItem(i)" v-tooltip.bottom="'Видалити'">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                                </svg>
                            </a>
                        </div>
                    </td>
                </tr>
            </table>
            </div>


            <div class="bottom_row">
                <div class="bottom_row_block">
                    <div class="row_item">
                        <p class="title">Комплектування в одній шафі</p>
                        <div class="input_group">
                            <label class="form_label">
                                <input v-model="completing_in_one_cabinet" value="yes" type="radio" class="form_radio" v-on:change="metalconstructionReload()" :disabled="!items.length">
                                <span class="selected_value weight-400">Так</span>
                            </label>
                            <label class="form_label">
                                <input v-model="completing_in_one_cabinet" value="no" type="radio" class="form_radio" v-on:change="metalconstructionReload()" :disabled="!items.length">
                                <span class="selected_value weight-400">Ні</span>
                            </label>
                        </div>
                    </div>
                    <div class="nominal_power">
                        <p class="title">Металоконструкція</p>
                        <select class="nominal_select metal_constr_select" v-model="metalconstruction" :disabled="!items.length || completing_in_one_cabinet==='no'">
                            <option :value="null">Відсутня</option>
                            <option v-for="(metalconstruction_product, i) in metalconstruction_products" :key="`p_${i}`" :value="metalconstruction_product">{{ metalconstruction_product.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="total_btns">
                    <a class="view_spec_btn" :class="{ 'disabled': !items.length }" v-on:click="() => {items.length ? modal_total = true : false}">Переглянути специфікацію</a>
                    <a class="download_spec" :class="{ 'disabled': !items.length }" v-on:click="() => {items.length ? getExcel() : false}">Завантажити специфікацію в Excel</a>
                </div>
            </div>
        </div>


        <div class="overlay" :class="{'zindexed': opensSliderModal || warningPopup}" v-if="modal_info || add_item_modal || modal_total || opensSliderModal || warningPopup" v-on:click="closeModals"></div>
        
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg id="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>

        <div class="modal add_item_modal" v-if="add_item_modal">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title" v-if="!editMode">Плавний пуск</p>
                    <p class="modal_header_title" v-else>Редагування</p>
                    <svg id="close_modal" v-on:click="closeModals()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div id="addMoadal" class="modal_content">
                    <div class="form_row">
                        <div class="info_form">
                            <div class="input_group">
                                <div class="form_input_item">
                                    <span class="form_input_title">
                                        Тип навантаження *
                                        <a href="#" v-tooltip.top="{ value: 'Даний параметр враховує технологічний процес і інерційність системи, змінюючи пусковий момент. Неправильний підбір типу роботи перевантажує двигун в момент пуску.' }">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M6.33337 3.66659H7.66671V4.99992H6.33337V3.66659ZM7.00004 10.3333C7.36671 10.3333 7.66671 10.0333 7.66671 9.66659V6.99992C7.66671 6.63325 7.36671 6.33325 7.00004 6.33325C6.63337 6.33325 6.33337 6.63325 6.33337 6.99992V9.66659C6.33337 10.0333 6.63337 10.3333 7.00004 10.3333ZM7.00004 0.333252C3.32004 0.333252 0.333374 3.31992 0.333374 6.99992C0.333374 10.6799 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.6799 13.6667 6.99992C13.6667 3.31992 10.68 0.333252 7.00004 0.333252ZM7.00004 12.3333C4.06004 12.3333 1.66671 9.93992 1.66671 6.99992C1.66671 4.05992 4.06004 1.66659 7.00004 1.66659C9.94004 1.66659 12.3334 4.05992 12.3334 6.99992C12.3334 9.93992 9.94004 12.3333 7.00004 12.3333Z" fill="#356EEF"/>
                                            </svg>
                                        </a>
                                    </span>
                                    <div class="select_container">
                                        <div class="custom_select form_select" @click="customDropdown=!customDropdown" :class="{ 'border-danger': errors.load_type }">
                                            <span class="custom_select_selected">{{preItem.load_type ? getLoadTypeTitle(preItem.load_type) : 'Оберіть значення'}}</span>
                                        </div>
                                        <ul class="custom_select_dropdown" :class="{'d-none': !customDropdown}">
                                            <li v-for="(load_type, i) in load_types" :key="`value_${i}`">
                                                <label class="custom_select_row">
                                                    <input type="checkbox" :value="load_type.id" v-model="dropped"/>

                                                    <span class="custom_select_title"><b>{{ load_type.label }}</b></span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                        <g clip-path="url(#clip0_6433_5571)">
                                                        <path d="M16.59 9.58984L12 14.1698L7.41 9.58984L6 10.9998L12 16.9998L18 10.9998L16.59 9.58984Z" fill="#356EEF"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_6433_5571">
                                                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                </label>
                                                <div class="custom_select_childrens" @click="customDropdown=false" v-if="dropped.includes(load_type.id)">
                                                    <label class="custom_select_children" :class="{'active': preItem.load_type === children.id}" v-for="(children, k) in load_type.children" :key="`child_${k}`">
                                                        <input type="radio" :value="children.id" v-model="preItem.load_type" v-on:change="getVariants()" />
                                                        <span class="custom_select_title">{{ children.label }}</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                        <p class="error_text" v-if="errors.load_type">Обов'язкове поле</p>
                                    </div>
                                </div>
                                <div class="form_input_item">
                                    <span class="form_input_title">Силова напруга В *</span>
                                    <div class="select_container">
                                        <select class="form_select" :class="{ 'border-danger': errors.power_voltage_v }" v-model="preItem.power_voltage_v" v-on:change="() => {preItem.current_a = null; preItem.power_kw = null; current_disabled=false; power_disabled=false; preItem.variants_soft_starts=[]; getVariants()}">
                                            <option :value="null" disabled selected>Оберіть значення</option>
                                            <option v-for="(power_voltage, i) in power_voltages" :key="`value_${i}`" :value="power_voltage.value">{{ power_voltage.label }}</option>
                                        </select>
                                        <p class="error_text" v-if="errors.power_voltage_v">Обов'язкове поле</p>
                                    </div>
                                </div>
                                <div class="form_input_item">
                                    <span class="form_input_title">Напруга керування В *</span>
                                    <div class="select_container">
                                        <select class="form_select" :class="{ 'border-danger': errors.control_voltage_v }" v-model="preItem.control_voltage_v" v-on:change="getVariants()">
                                            <option :value="null" disabled selected>Оберіть значення</option>
                                            <option v-for="(control_voltage, i) in control_voltages" :key="`value_${i}`" :value="control_voltage.value">{{ control_voltage.label }}</option>
                                        </select>
                                        <p class="error_text" v-if="errors.control_voltage_v">Обов'язкове поле</p>
                                    </div>
                                </div>
                                <div class="form_input_item">
                                    <span class="form_input_title">Кількість пусків на годину *</span>
                                    <div class="select_container">
                                        <input class="form_input" type="number" min="0" :class="{ 'border-danger': errors.number_launches_per_hour }" @input="getVariants" v-model="preItem.number_launches_per_hour">
                                        <p class="error_text" v-if="errors.number_launches_per_hour">Обов'язкове поле</p>
                                    </div>
                                </div>
                            </div>
                            <div class="input_group">
                                <div class="form_input_item">
                                    <span class="form_input_title">Потужність кВт *</span>
                                    <div class="select_container">
                                        <input class="form_input" type="number" min="0" :class="{ 'border-danger': errors.power_kw }" :disabled="power_disabled" @input="getVariantsPower" v-model="preItem.power_kw">
                                        <p class="error_text" v-if="errors.power_kw">Обов'язкове поле</p>
                                    </div>
                                </div>

                                <div class="form_input_item">
                                    <span class="form_input_title">Струм А *</span>
                                    <div class="select_container">
                                        <input class="form_input" type="number" min="0" :class="{ 'border-danger': errors.current_a }" :disabled="current_disabled" @input="getVariantsCurrent" v-model="preItem.current_a">
                                        <p class="error_text" v-if="errors.current_a">Обов'язкове поле</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="variation_table">
                        <p class="subtitle">Підбірка варіантів плавних пусків</p>

                        <div class="main_table_container">
                            <table class="main_table">
                                <tr>
                                    <th class="main_table_title" rowspan="2" style="min-width: 133px;">Тип</th>
                                    <th class="main_table_title" rowspan="2">Струм / Потужність</th>
                                    <th class="main_table_title" rowspan="2">Кількість керованих фаз</th>
                                    <th class="main_table_title" colspan="2">Керування</th>
                                    <th class="main_table_title" colspan="2">Аналогові</th>
                                    <th class="main_table_title" colspan="2">Цифрові</th>
                                    <th class="main_table_title" colspan="1">Захист</th>
                                    <th class="main_table_title" colspan="1">Панель керування</th>
                                    <th class="main_table_title" rowspan="2">Тип воду параметрів</th>
                                    <th class="main_table_title" rowspan="2">Кількість пусків на годину</th>
                                    <th class="main_table_title" rowspan="2">Комунікаційний порт</th>
                                    <th class="main_table_title" rowspan="2" style="min-width: 92px;"></th>
                                </tr>
                                <tr>
                                    <th class="main_table_title">Розгон/зупинка</th>
                                    <th class="main_table_title">Старт/стоп</th>
                                    <th class="main_table_title">NO</th>
                                    <th class="main_table_title">NC</th>
                                    <th class="main_table_title">VC</th>
                                    <th class="main_table_title">CC</th>
                                    <th class="main_table_title">IP</th>
                                    <th class="main_table_title">Інтерфейс</th>
                                </tr>

                                <tr v-for="(item, i) in preItem.variants_soft_starts" :key="`item_${i}`">
                                    <td class="main_table_row" style="text-align: start; padding-left:10px;">
                                        <div style="display: flex; align-items: center; gap:5px;">
                                            <a href="#" @click="opensSliderModalAction(item.article)" style="display: flex; align-items: center;">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                                    <g clip-path="url(#clip0_6826_6852)">
                                                    <path d="M14.25 2.75H3.75C2.925 2.75 2.25 3.425 2.25 4.25V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V4.25C15.75 3.425 15.075 2.75 14.25 2.75ZM13.5 14.75H4.5C4.0875 14.75 3.75 14.4125 3.75 14V5C3.75 4.5875 4.0875 4.25 4.5 4.25H13.5C13.9125 4.25 14.25 4.5875 14.25 5V14C14.25 14.4125 13.9125 14.75 13.5 14.75ZM10.17 10.1075L8.4075 12.3725L7.2375 10.9625C7.0875 10.775 6.8025 10.7825 6.6525 10.97L5.3475 12.6425C5.1525 12.89 5.3325 13.25 5.64 13.25H12.375C12.6825 13.25 12.8625 12.8975 12.675 12.65L10.7625 10.1075C10.62 9.9125 10.32 9.9125 10.17 10.1075Z" fill="#356EEF"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_6826_6852">
                                                    <rect width="18" height="18" fill="white" transform="translate(0 0.5)"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                            </a>
                                            {{ item.article }}
                                        </div>
                                    </td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.current }}А / {{ item.power }}кВт</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var2 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var3 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var4 }}</td>
                                    <td class="main_table_row" style="text-align: center;" data_field="NO">{{ item.info.var5 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var6 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var7 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var8 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var9 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var10 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var11 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var12 }}</td>
                                    <td class="main_table_row" style="text-align: center;">{{ item.info.var13 }}</td>
                                    <td class="main_table_row" style="text-align: center;padding: 5px;">
                                        <a href="#" class="select_item_btn" @click="selectItem(item)">Обрати</a>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div class="btn_container" v-if="loading">
                            <a class="view_spec_btn disabled">Завантаження..</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal modal_total" v-if="modal_total">
            <div class="modal_header">
                <p class="modal_header_title">Специфікація</p>
                <svg id="close_modal" v-on:click="() => {modal_total = false; summarize = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="modal_content">
                <br>
                <br>

                <template v-if="!summarize">
                    <template v-for="(item, i) in specItems" :key="`itemi_${i}`">
                        <p class="title">{{ item.title }}</p>
                        <table style="width:100%; z-index:1;" border=1>
                            <thead>
                                <th class="total_key summ_text">#</th>
                                <th class="total_title summ_text">Найменування</th>
                                <th class="total_maker summ_text">Виробник</th>
                                <th class="total_count summ_text">Кількість</th>
                                <th class="total_od summ_text">Од. Вим.</th>
                                <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                                <th class="total_summ2 center summ_text">Сума, грн. без ПДВ</th>
                                <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in item.products" :key="`item_${i}`">
                                    <td class="total_key">{{ i+1 }}</td>
                                    <td class="total_title">{{ item.description }}</td>
                                    <td class="total_maker">{{ item.maker }}</td>
                                    <td class="total_count">{{ parseInt(item.count) }}</td>
                                    <td class="total_od">шт.</td>
                                    <td class="total_price">{{ numberWithSpaces(item.price_nds/1.2) }}</td>
                                    <td class="total_summ2">{{ numberWithSpaces((item.price_nds/1.2) * parseInt(item.count)) }}</td>
                                    <td class="total_tech">
                                        <a :href="item.tech_char" target="_blank">
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                            </svg>
                                        </a>
                                    </td>
                                </tr>
                                <tr class="totat_tr">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                    <td class="summ_text summ_value">{{ summProducts(item.products) }}</td>
                                    <td></td>
                                </tr>
                                <tr class="totat_tr">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                    <td class="summ_text summ_value">{{ productsPdw(item.products) }}</td>
                                    <td></td>
                                </tr>
                                <tr class="totat_tr">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                    <td class="summ_text summ_value">{{ summProductsPdw(item.products) }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                        <br>
                        <br>
                    </template>
                </template>
                <template v-if="summarize">
                    <table style="width:100%; z-index:1;" border=1>
                        <thead>
                            <th class="total_key summ_text">#</th>
                            <th class="total_title summ_text">Найменування</th>
                            <th class="total_maker summ_text">Виробник</th>
                            <th class="total_count summ_text">Кількість</th>
                            <th class="total_od summ_text">Од. Вим.</th>
                            <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                            <th class="total_summ2 center summ_text">Сума, грн. без ПДВ</th>
                            <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in summarizeResult" :key="`item_${i}`">
                                <td class="total_key">{{ i+1 }}</td>
                                <td class="total_title">{{ item.description }}</td>
                                <td class="total_maker">{{ item.maker }}</td>
                                <td class="total_count">{{ parseInt(item.count) }}</td>
                                <td class="total_od">шт.</td>
                                <td class="total_price">{{ numberWithSpaces(item.price_nds/1.2) }}</td>
                                <td class="total_summ2">{{ numberWithSpaces((item.price_nds/1.2) * parseInt(item.count)) }}</td>
                                <td class="total_tech">
                                    <a :href="item.tech_char" target="_blank">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                <td class="summ_text summ_value">{{ summProducts(summarizeResult) }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                <td class="summ_text summ_value">{{ productsPdw(summarizeResult) }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                <td class="summ_text summ_value">{{ summProductsPdw(summarizeResult) }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <br>
                </template>
            </div>
            <div class="modal_bottom">
                <a href="javascript:void(0)" v-on:click="() => {modal_total = false; summarize = false;}" class="modal_bottom_link">Повернутись до конфігуратора</a>
                <div class="modal_bottom__btns">
                    <a href="javascript:void(0)" v-on:click="doSummarize()" class="avr_summ_btn">
                        <span v-if="!summarize">Підсумувати</span>
                        <span v-if="summarize">Розділити</span>
                    </a>
                    <a href="javascript:void(0)" v-on:click="getExcel()" class="avr_excel_btn">Завантажити Excel</a>
                </div>
            </div>

            <div class="commercial_offer">
                <div class="commercial_offer_header" @click="dropCommercialOfferForm()">
                    <span class="commercial_offer_header_title">Замовити комерційну пропозицію</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{commercial_offer_drop_row: is_drop_commercial_offer}">
                        <g clip-path="url(#clip0_7979_151607)">
                            <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" fill="#356EEF"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_7979_151607">
                            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="commercial_offer_body" v-if="is_drop_commercial_offer">
                    <p class="commercial_offer_body_subtitle">Заповніть форму</p>
                    
                    <div class="flex-group customer_info">
                        <div class="flex_form">
                            <div class="flex-row">
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Організація</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.organization }" v-model="commercialOfferData.organization" type="text" placeholder="Назва" />
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Контактна особа</label>
                                        <input class="form_input" v-model="commercialOfferData.name" type="text" placeholder="ПІБ" />
                                    </div>
                                </div>
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Номер телефону *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.phone }" @input="acceptNumber" v-model="commercialOfferData.phone" type="text" placeholder="+380" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.phone">Обов'язкове поле</p>
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Електронна пошта *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.email }" v-model="commercialOfferData.email" type="text" placeholder="Email" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.email">Обов'язкове поле</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex_form">
                            <div class="form_group mr-9">
                                <label class="form_label">Комментар до замовлення</label>
                                <div class="textarea_container">
                                    <textarea v-model="commercialOfferData.comment" class="form_input form_textarea" maxlength="200" rows="5" placeholder="Коментар"></textarea>
                                    <span class="total_words">{{ commercialOfferData.comment ? commercialOfferData.comment.length : 0 }} / 200</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="commercial_offer_order" v-if="commercial_offer_sended">
                        <div class="block_row">
                            <p class="commercial_offer_order_title">Заявка №{{commercial_offer_id}} від</p>
                            <svg id="close_offer" @click="() => {commercial_offer_sended = false; is_disable_commercial_offer_btn = false}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"></path>
                            </svg>
                        </div>
                        <p class="commercial_offer_order_title">{{commercial_offer_created_at}}</p>
                        <p class="commercial_offer_order_text">Ваша запит на Комерційну пропозицію  зареєстрований та прийнятий, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                    </div>

                    <a href="javascript:void(0)" v-if="!commercial_offer_sended" :disabled="is_disable_commercial_offer_btn" class="commercial_offer_order_btn" @click="commercialOrder()">
                        <template v-if="is_disable_commercial_offer_btn">
                            Зачекайте... <ProgressSpinner strokeWidth="5" style="width: 30px; height: 30px; margin: 0; margin-left: 30px;" />
                        </template>
                        <template v-else>Замовити</template>
                    </a>
                    <a href="javascript:void(0)" v-else class="commercial_offer_order_btn disabled">
                        Замовити
                    </a>
                </div>
            </div>
        </div>

        <div class="modal product_media_modal" v-if="opensSliderModal">
            <div class="modal_container">
                <svg id="close_modal" v-on:click="() => {opensSliderModal = false; overlay = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
                <div class="modal_content">
                    <div class="product_media_modal_main_img_container">
                        <h4>{{ mediaPopup.title }}</h4>
                        <div class="product_media_modal_row">
                            <img :src="mediaPopup.image" class="product_media_modal_main_img" alt="image">
                            <p class="product_media_modal_description" v-html="mediaPopup.description"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Transition>
        <div class="notification_bar" v-if="progressSaved">
            <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4984_330032)">
                <path d="M13.7125 24.3004L7.4125 18.0004L5.3125 20.1004L13.7125 28.5004L31.7125 10.5004L29.6125 8.40039L13.7125 24.3004Z" fill="white"/>
                </g>
                <defs>
                <clipPath id="clip0_4984_330032">
                <rect width="36" height="36" fill="white"/>
                </clipPath>
                </defs>
                </svg>
                
                <b>Зміни збережені.</b>
            </span>
        </div>
        </Transition>
        <Transition>
        <div class="notification_bar error" v-if="progressSavedError">
            <span>
                <svg fill="#000000" height="20" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                    viewBox="0 0 460.775 460.775" xml:space="preserve">
                    <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                        c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                        c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                        c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                        l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                        c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
                </svg>
                
                <b>Помилка збереження!</b>
            </span>
        </div>
        </Transition>
    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Label from '../Jetstream/Label.vue';
import Input from '../Jetstream/Input.vue';
import CustomSelect from "../Components/CustomSelect2.vue";
import Tooltip from 'primevue/tooltip';
import ProgressSpinner from 'primevue/progressspinner';


export default {
    directives: {
        Tooltip,
    },
    props: {
        text: {
            type: String,
            required: false,
        }
    },

    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        Input,
        Label,
        CustomSelect,
        ProgressSpinner,
    },
    layout: CommonLayout,

    data() {
        return {
            loading: false,
            customDropdown: false,
            dropped: [],

            modal_info: false,
            modal_docs: false,
            modal_total: false,
            summarize: false,

            add_item_modal: false,
            opensSliderModal: false,
            selectedMediaIndex: 0,

            defaultMedia: [],

            power_voltages: [],
            control_voltages: [],

            power_disabled: false,
            current_disabled: false,

            specItems: [],

            preItem: {
                automatic_switches: [], //варіант Автоматичний вимикач
                automatic_switch: null, //Автоматичний вимикач
                fuses: [], //Запобіжник
                fuse: null, //Запобіжник
                fuse_holders: [], //варіант Тримач запобіжника
                fuse_holder: null, //Тримач запобіжника
                contactors: [], //варіант Контактор
                contactor: null, //Контактор
                smooth_start: null, //Плавний пуск
                fan: null, //Вентилятор
                power_board: null, //Плата живлення
                wardrobe: null, //Шафа
                load_type: null, //Тип навантаження
                power_kw: null, //Потужність кВт *
                current_a: null, //Струм А *
                number_launches_per_hour: null, //Кількість пусків на годину *
                power_voltage_v: null, //Силова напруга В *
                control_voltage_v: null, //Напруга керування В *
                variants_soft_starts: [], //варіанти плавних пусків
                variants_soft_start: null, //варіант плавних пусків
                selectedProductMediaFiles: [],
                metalconstruction: null,
                metalconstruction_products: [],
            },
            completing_in_one_cabinet: 'yes',
            metalconstruction: null,
            metalconstruction_products: [],
            load_types: [],
            products_length: false,

            items: [],

            payload: false,
            editMode: false,
            editKey: false,
            error: null,
            errors: {
                load_type: false,
                power_kw: false,
                current_a: false,
                number_launches_per_hour: false,
                power_voltage_v: false,
                control_voltage_v: false,
            },
            hasFormError: false,


            summarizeResult: [],

            selectedProductMediaFiles: [],

            progressSaved: false,
            progressSavedError: false,

            warningPopup: false,

            mediaPopup: {
                image: 'https://vector-vs.com/uploads/TEMP/Pusto/Pusto.jpg',
                title: 'Плавний пуск',
                description: '',
            },

            is_drop_commercial_offer: false,
            commercial_offer_sended: false,
            is_disable_commercial_offer_btn: false,
            commercial_offer_id: null,
            commercial_offer_created_at: null,
            commercialOfferData: {
                organization: null,
                name: null,
                phone: null,
                email: null,
                comment: null,
            },
            commercialOfferDataErrors: {
                phone: null,
                email: null,
            },
        }
    },


    beforeMount () {
        window.addEventListener('keydown', this.handleKeydown, null);
    },
    mounted() {
        this.getData();
    },
    beforeDestroy () {
        window.removeEventListener('keydown', this.handleKeydown);
    },

    watch: {
        'items': {
            handler: function(data) {
                let specItems = []

                // console.log(this.items)

                data.forEach(function (item, index) {
                    specItems.push({
                        title: 'Плавний пуск: ' + item.variants_soft_start.article,
                        products: []
                    })

                    if (item.variants_soft_start) {
                        specItems[index].products.push({
                            description: item.variants_soft_start.article,
                            maker: item.variants_soft_start.brand,
                            count: 1,
                            price_nds: item.variants_soft_start.price,
                            tech_char: item.variants_soft_start.tech_char,
                        })
                    }

                    if (item.automatic_switch) {
                        specItems[index].products.push({
                            description: item.automatic_switch.description,
                            maker: item.automatic_switch.brand,
                            count: 1,
                            price_nds: item.automatic_switch.price,
                            tech_char: item.automatic_switch.tech_char,
                        })
                    }

                    if (item.fuse) {
                        specItems[index].products.push({
                            description: item.fuse.description,
                            maker: item.fuse.brand,
                            count: item.fuse.leave_rate ? item.fuse.leave_rate : 1,
                            price_nds: item.fuse.price,
                            tech_char: item.fuse.tech_char,
                        })
                    }

                    if (item.fuse_holder) {
                        specItems[index].products.push({
                            description: item.fuse_holder.description,
                            maker: item.fuse_holder.brand,
                            count: item.fuse_holder.leave_rate ? item.fuse_holder.leave_rate : 1,
                            price_nds: item.fuse_holder.price,
                            tech_char: item.fuse_holder.tech_char,
                        })
                    }

                    if (item.contactor) {
                        specItems[index].products.push({
                            description: item.contactor.description,
                            maker: item.contactor.brand,
                            count: 1,
                            price_nds: item.contactor.price,
                            tech_char: item.contactor.tech_char,
                        })
                    }

                    if (item.fan && item.fan.price > 0) {
                        specItems[index].products.push({
                            description: item.fan.fan,
                            maker: item.fan.brand,
                            count: 1,
                            price_nds: item.fan.price,
                            tech_char: item.fan.tech_char,
                        })
                    }

                    if (item.power_board && item.power_board.price > 0) {
                        specItems[index].products.push({
                            description: item.power_board.control_voltage_article ? item.power_board.control_voltage_article : item.power_board.description,
                            maker: item.power_board.brand,
                            count: 1,
                            price_nds: item.power_board.price,
                            tech_char: item.power_board.tech_char,
                        })
                    }

                    if (item.metalconstruction) {
                        specItems[index].products.push({
                            description: item.metalconstruction.name,
                            maker: item.metalconstruction.brand,
                            count: 1,
                            price_nds: item.metalconstruction.price,
                            tech_char: item.metalconstruction.tech_char,
                        })
                    }
                });

                this.specItems = specItems;
            },
            deep: true
        },
        'metalconstruction': {
            handler: function(item) {
                if (item) {
                    this.specItems.push({
                        title: 'Металконструкція: ' + item.article,
                        products: [
                            {
                                description: item.name,
                                maker: item.brand,
                                count: 1,
                                price_nds: item.price,
                                tech_char: item.tech_char,
                            }
                        ]
                    })
                } else {
                    this.specItems = this.specItems.filter(x => !x.title.includes('Металконструкція'))
                }
            },
            deep: true
        },
    },

    methods: {
        getData() {
            this.payload = true;
            this.error = false;
            axios.post(this.route('api.plavni_spusky_data'))
                .then((result) => {
                    // this.metalconstruction_products = result.data.metalconstruction_products;
                    this.load_types = result.data.load_types;
                    this.power_voltages = result.data.power_voltages;
                    this.control_voltages = result.data.control_voltages;

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        metalconstructionReload() {
            if (this.completing_in_one_cabinet === 'yes') {
                this.items.forEach(function (item) {
                    if (item) {
                        item.metalconstruction = null
                    }
                });
            } else {
                this.metalconstruction = null
            }
        },

        selectListItem (index, item) {
            let postData = {
                article: item.variants_soft_start.article,
                is_automaton: item.automatic_switch ? true : false,
                is_fuse: item.fuse ? true : false,
                is_contactor: item.contactor ? true : false,
            };

            this.items[index].metalconstruction = null

            axios.post(this.route('api.get_variant_metalconstructions', {data: postData}))
            .then((result) => {
                this.items[index].metalconstruction_products = result.data.item_metalconstruction_products;

                this.payload = false;
            }).catch((error) => {
                this.error = true;
                window.scroll(0, 0);
            })

            this.progressSaved = true

            setTimeout(function () { this.progressSaved = false }.bind(this), 900)
        },

        async selectItem (item) {
            this.add_item_modal = false;
            this.preItem.variants_soft_start = item;

            let preItem = _.cloneDeep( this.preItem );
            let items = _.cloneDeep( this.items );

            if (this.editMode) {
                this.items[this.editKey] = preItem;
            }

            let articles = []
            items.forEach(function (pitem) {
                if (pitem) {
                    articles.push(pitem.variants_soft_start.article);
                }
            });

            if (!this.editMode) {
                articles.push(item.article)
            }

            let postData = {
                article: item.article,
                articles: articles,
                completing_in_one_cabinet: this.completing_in_one_cabinet,
                count: this.editMode ? this.items.length : this.items.length + 1,
                load_type: preItem.load_type,
                power_kw: preItem.power_kw,
                current_a: preItem.variants_soft_start.current,
                number_launches_per_hour: preItem.number_launches_per_hour,
                power_voltage_v: preItem.power_voltage_v,
                control_voltage_v: preItem.control_voltage_v,
                is_automaton: item.automatic_switch ? true : false,
                is_fuse: item.fuse ? true : false,
                is_contactor: item.contactor ? true : false,
            };

            axios.post(this.route('api.get_variant', {data: postData}))
                .then((result) => {
                    if (this.editMode) {
                        this.items[this.editKey].automatic_switch = null;
                        this.items[this.editKey].fuse = null;
                        this.items[this.editKey].fuse_holder = null;
                        this.items[this.editKey].contactor = null;


                        this.items[this.editKey].automatic_switches = result.data.automatic_switches;
                        this.items[this.editKey].fuses = result.data.fuses;
                        this.items[this.editKey].fuse_holders = result.data.fuse_holders;
                        this.items[this.editKey].contactors = result.data.contactors;
                        this.items[this.editKey].fan = result.data.fan;
                        this.items[this.editKey].power_board = result.data.power_board;
                        this.items[this.editKey].metalconstruction_products = result.data.item_metalconstruction_products;
                    
                    } else {
                        preItem.automatic_switches = result.data.automatic_switches;
                        preItem.fuses = result.data.fuses;
                        preItem.fuse_holders = result.data.fuse_holders;
                        preItem.contactors = result.data.contactors;
                        preItem.fan = result.data.fan;
                        preItem.power_board = result.data.power_board;
                        preItem.metalconstruction_products = result.data.item_metalconstruction_products;

                        this.items.push(preItem)
                    }

                    this.metalconstruction_products = result.data.metalconstruction_products

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })

            this.progressSaved = true

            setTimeout(function () { this.progressSaved = false }.bind(this), 900)

            this.preItem = {
                automatic_switch: null, //Автоматичний вимикач
                automatic_switches: [], //варіант Автоматичний вимикач
                fuses: [], //варіант Запобіжник
                fuse: null, //Запобіжник
                fuse_holders: [], //варіант Тримач запобіжника
                fuse_holder: null, //Тримач запобіжника
                contactors: [], //варіант Контактор
                contactor: null, //Контактор
                smooth_start: null, //Плавний пуск
                fan: null, //Вентилятор
                power_board: null, //Плата живлення
                wardrobe: null, //Шафа
                load_type: null, //Тип навантаження
                power_kw: null, //Потужність кВт *
                current_a: null, //Струм А *
                number_launches_per_hour: null, //Кількість пусків на годину *
                power_voltage_v: null, //Силова напруга В *
                control_voltage_v: null, //Напруга керування В *
                variants_soft_starts: [], //варіанти плавних пусків
                variants_soft_start: null, //варіант плавних пусків
                selectedProductMediaFiles: [],
                metalconstruction: null,
                metalconstruction_products: [],
            };

            await this.$nextTick();
        },

        getMetalConstruction () {
            let articles = []
            this.items.forEach(function (pitem) {
                if (pitem) {
                    articles.push(pitem.variants_soft_start.article);
                }
            });

            let postData = {
                articles: articles,
                count: this.items.length,
            };

            axios.post(this.route('api.get_metalconstructions', {data: postData}))
                .then((result) => {
                    this.metalconstruction_products = result.data.metalconstruction_products

                    this.payload = false;
                    this.progressSaved = true
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })

            setTimeout(function () { this.progressSaved = false }.bind(this), 900)
        },

        getVariantsPower() {
            this.current_disabled = false;
            if (this.preItem.power_kw && this.preItem.power_kw >= 0) {
                this.current_disabled = true;
            } else {
                this.preItem.current_a = null;
            }
            this.power_disabled = false;

            if (this.preItem.power_voltage_v === '220 (1-phase)' && this.preItem.power_kw && this.preItem.power_kw >= 0) {
                this.preItem.current_a = parseFloat(parseFloat(this.preItem.power_kw * 1000 / (220*0.8)).toFixed(2))
            }

            if (this.preItem.power_voltage_v === '380 (3-phase)' && this.preItem.power_kw && this.preItem.power_kw >= 0) {
                this.preItem.current_a = parseFloat(parseFloat(this.preItem.power_kw * 1000 / (380 * 0.87 * Math.sqrt(3))).toFixed(2))
            }

            this.getVariants()
        },

        getVariantsCurrent() {
            this.power_disabled = false;
            if (this.preItem.current_a && this.preItem.current_a >= 0) {
                this.power_disabled = true;
            } else {
                this.preItem.power_kw = null;
            }

            this.current_disabled = false;

            if (this.preItem.power_voltage_v === '220 (1-phase)' && this.preItem.current_a && this.preItem.current_a >= 0) {
                this.preItem.power_kw = parseFloat(parseFloat(this.preItem.current_a * 220 * 0.8 / 1000).toFixed(2))
            }

            if (this.preItem.power_voltage_v === '380 (3-phase)' && this.preItem.current_a && this.preItem.current_a >= 0) {
                this.preItem.power_kw = parseFloat(parseFloat(this.preItem.current_a * 380 * 0.87 * Math.sqrt(3)/1000).toFixed(2))
            }

            this.getVariants()
        },

        getVariants() {
            this.payload = true;
            this.errors = {
                load_type: false,
                power_kw: false,
                current_a: false,
                number_launches_per_hour: false,
                power_voltage_v: false,
                control_voltage_v: false,
            }

            let error = false

            if (!this.preItem.load_type) {
                this.errors.load_type = true;
                error = true
            } else if (!this.preItem.current_a && (this.preItem.power_kw === null || this.preItem.power_kw == '')) {
                this.errors.power_kw = true;
                error = true
            } else if (!this.preItem.power_kw && (this.preItem.current_a === null || this.preItem.current_a == '')) {
                this.errors.current_a = true;
                error = true
            } else if (this.preItem.number_launches_per_hour === null || this.preItem.number_launches_per_hour == '') {
                this.errors.number_launches_per_hour = true;
                error = true
            } else if (!this.preItem.power_voltage_v) {
                this.errors.power_voltage_v = true;
                error = true
            } else if (!this.preItem.control_voltage_v) {
                this.errors.control_voltage_v = true;
                error = true
            }

            if (this.preItem.power_voltage_v === '220 (1-phase)') {
                this.power_disabled = true;
                this.errors.power_kw = false;
                if (this.preItem.current_a === null || this.preItem.current_a == '') {
                    this.errors.current_a = true;
                }
            } else if (this.preItem.current_a === null || this.preItem.current_a == '') {
                this.errors.current_a = true;
            }

            if (!error) {
                let postData = {
                    load_type: this.preItem.load_type,
                    power_kw: this.power_disabled ? null : this.preItem.power_kw,
                    current_a: this.current_disabled ? null : this.preItem.current_a,
                    number_launches_per_hour: this.preItem.number_launches_per_hour,
                    power_voltage_v: this.preItem.power_voltage_v,
                    control_voltage_v: this.preItem.control_voltage_v,
                };

                axios.post(this.route('api.get_variants', {data: postData}))
                    .then((result) => {
                        this.preItem.variants_soft_starts = result.data.data;

                        this.preItem.automatic_switches = result.data.automatic_switches;
                        this.preItem.fuses = result.data.fuses;
                        this.preItem.fuse_holders = result.data.fuse_holders;
                        this.preItem.contactors = result.data.contactors;

                        this.payload = false;
                    }).catch((error) => {
                        this.error = true;
                        window.scroll(0, 0);
                    })
            }
        },

        getLoadTypeTitle (id) {
            for (const [i, value] of Object.entries(this.load_types)) {
                for (const [k, child] of Object.entries(value.children)) {
                    if (child.id == id) {
                        return child.label;
                    }
                }
            }
        },
        
        handleKeydown (e) {
            if (this.opensSliderModal) {
                switch (e.keyCode) {
                    case 37:
                        this.selectedMediaIndex > 0 ? this.selectedMediaIndex-- : this.selectedMediaIndex
                        break;
                    case 39: 
                        this.modalNextMedia();
                        break;
                    case 27: 
                        this.opensSliderModal = false;
                        this.overlay = false;
                        break;
                }
            }
        },
        openAddModal() {
            this.add_item_modal = true;
        },
        editProduct(key) {
            this.add_item_modal = true;
            this.editMode = true;
            this.editKey = key
            this.preItem = _.cloneDeep(this.items[key])

            this.$forceUpdate();
        },
        addItem(isConfirm = false) {
            this.errors = [];

            this.add_item_modal = false;

            this.$forceUpdate();
        },

        scrollTop(id) {
            const el = document.getElementById(id);

            if (el) {
                el.scrollTop = 0;
            }
        },

        isMobile() {
            return window.innerWidth <= 1024;
        },
        numberWithSpaces(x) {
            x = parseFloat(x);
            x = x.toFixed(2);
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(",");
        },

        summTotal() {
            let summ = 0;
            
            this.items.forEach((value, index) => {
                if (value) {
                    let itemSumm = parseInt(value.count) * value.price;
                    summ += itemSumm;
                    value.summ = itemSumm;
                }
            });

            return this.numberWithSpaces(summ);
        },

        copyItem(index) {
            this.selectedMediaIndex = 0;
            this.editMode = true
            this.editKey = index

            let item = _.cloneDeep( this.items[index] );

            this.items.splice(index, 0, item);

            this.getMetalConstruction();
        },

        deleteItem(key) {
            this.selectedMediaIndex = 0;
            this.items.splice(key, 1);

            this.getMetalConstruction();
        },
        
        summProducts(items) {
            let summ = 0;

            items.forEach((item, index) => {
                if (item) {
                    summ += parseInt(item.count) * (item.price_nds/1.2);
                }
            });

            return this.numberWithSpaces(summ);
        },
        
        productsPdw(items) {
            let summ = 0;
            let summPdv = 0;

            items.forEach((item, index) => {
                if (item) {
                    summ += parseInt(item.count) * item.price_nds;
                }
            });

            items.forEach((item, index) => {
                if (item) {
                    summPdv += parseInt(item.count) * (item.price_nds/1.2);
                }
            });

            return this.numberWithSpaces(summ - summPdv);
        },
        
        summProductsPdw(items) {
            let summ = 0;

            items.forEach((item, index) => {
                if (item) {
                    summ += parseInt(item.count) * item.price_nds;
                }
            });

            return this.numberWithSpaces(summ);
        },

        doSummarize() {
            this.summarize = !this.summarize;
            this.summarizeResult = [];
            let articles = [];

            let items = _.cloneDeep(this.specItems)

            let preSumm = [];

            items.forEach((item, index) => {
                if (item) {
                    item.products.forEach((product, key) => {
                        preSumm.push(product);
                    });
                }
            });

            const uniqueData = Object.values(
                preSumm.reduce((acc, item) => {
                    if (!item.article) {
                        // Если article отсутствует, добавляем элемент с уникальным ключом
                        if (!acc[item.description]) {
                            item.count = parseInt(item.count);
                            acc[item.description] = { ...item }; // Если article уникален, добавляем в объект
                        } else {
                            acc[item.description].count += parseInt(item.count); // Если уже есть, суммируем count
                        }
                    } else if (!acc[item.article]) {
                        // Если article уникален, добавляем элемент
                        item.count = parseInt(item.count);
                        acc[item.article] = { ...item };
                    } else {
                        // Если article уже существует, суммируем count
                        acc[item.article].count += parseInt(item.count);
                    }
                    return acc;
                }, {})
            );

            console.log(preSumm)
            console.log(uniqueData)

            this.summarizeResult = uniqueData

            this.$forceUpdate();
        },

        getExcel() {
            if (!this.items.length) {
                return;
            }

            this.modal_total = false;

            axios.post(this.route('api.plavni_spusky_get_excel'), {
                items: this.summarize ? this.summarizeResult : this.specItems,
                summarize: this.summarize,
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        modalNextMedia() {
            if (this.selectedMediaIndex <= this.preItem.selectedProductMediaFiles.length - 2) {
                this.selectedMediaIndex++
            } else {
                this.selectedMediaIndex = 0
            }
            this.$forceUpdate();
        },
        opensSliderModalAction(article) {
            if (article.includes('PFE')) {
                this.mediaPopup.image = '/img/pfe.png';
                this.mediaPopup.title = 'Плавний пуск: ' + article;
                this.mediaPopup.description = 'З потужністю від 2,2 кВт до 22 кВт, VMX-PFE™ ідеально підходить для підтримки невеликих асинхронних двигунів змінного струму. Легкий монтаж на DIN-рейку робить VMX-PFE™ природним вибором для дистриб\'юторів і клієнтів. <br><br> Завдяки передовій інженерній майстерності Motortronics VMX-PFE™ поєднує в собі якість і надійність, яких ви звикли очікувати. Це один продукт, який відповідає всім вимогам.';
            } else if (article.includes('AGY')) {
                this.mediaPopup.image = '/img/agy.png';
                this.mediaPopup.title = 'Плавний пуск: ' + article;
                this.mediaPopup.description = 'VMX-agility™ було розроблено, щоб перевершити суворі вимоги клієнтів промислової автоматизації керування двигунами. VMX-agility™ забезпечує стабільний старт і зупинку для плавної та ефективної роботи. Три стандартні типорозміри охоплюють усі типи застосування від 7,5 кВт до 250 кВт при 500 В змінному струмі, 15 - 350 к.с. при 600 У змінному струмі.';
            } else if (article.includes('SGY')) {
                this.mediaPopup.image = '/img/sgy.png';
                this.mediaPopup.title = 'Плавний пуск: ' + article;
                this.mediaPopup.description = 'Завдяки унікальному поєднанню функцій, продуктивності та розміру Motortronics переосмислила еталон для конструкції пристрою плавного пуску. <br><br> Впровадження унікальної технології iERS від Motortronics дозволяє VMX-synergy™ забезпечувати неперевершену продуктивність плавного пуску разом із можливістю економії енергії на частково навантажених двигунах.';
            } else {
                this.mediaPopup.image = 'https://vector-vs.com/uploads/TEMP/Pusto/Pusto.jpg';
                this.mediaPopup.title = 'Плавний пуск';
                this.mediaPopup.description = '';
            }

            this.opensSliderModal = !this.opensSliderModal;
            this.overlay = true;
            this.$forceUpdate();
        },

        closeModals() {
            if (this.opensSliderModal) {
                this.opensSliderModal = false
            } else if (this.warningPopup) {
                this.warningPopup = false;
            } else {
                this.modal_info = false;
                this.add_item_modal = false;
                this.modal_total = false;

                this.editMode = false;
                this.editKey = null
                this.preItem = {
                    automatic_switches: [], //варіант Автоматичний вимикач
                    automatic_switch: null, //Автоматичний вимикач
                    fuse: null, //Запобіжник
                    fuse_holder: null, //Тримач запобіжника
                    contactor: null, //Контактор
                    smooth_start: null, //Плавний пуск
                    fan: null, //Вентилятор
                    power_board: null, //Плата живлення
                    wardrobe: null, //Шафа
                    load_type: null, //Тип навантаження
                    power_kw: null, //Потужність кВт *
                    current_a: null, //Струм А *
                    number_launches_per_hour: null, //Кількість пусків на годину *
                    power_voltage_v: null, //Силова напруга В *
                    control_voltage_v: null, //Напруга керування В *
                    variants_soft_starts: [], //варіанти плавних пусків
                    variants_soft_start: null, //варіант плавних пусків
                    selectedProductMediaFiles: [],
                };
            }
        },

        dropCommercialOfferForm() {
            this.is_drop_commercial_offer = !this.is_drop_commercial_offer
        },
        acceptNumber() {
            var x = this.commercialOfferData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.commercialOfferData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },
        commercialOrder() {
            if (!this.commercialOfferData.phone) {
                this.commercialOfferDataErrors.phone = true;
                return false;
            } else {
                this.commercialOfferDataErrors.phone = false;
            }
            if (!this.commercialOfferData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.commercialOfferData.email))) {
                this.commercialOfferDataErrors.email = true;
                return false;
            } else {
                this.commercialOfferDataErrors.email = false;
            }

            if (!this.is_disable_commercial_offer_btn) {
                this.is_disable_commercial_offer_btn = true;

                axios.post(this.route('make-offer'), {
                    type: 'PlavniSpuskyService',

                    items: this.summarize ? this.summarizeResult : this.specItems,
                    summarize: this.summarize,

                    organization: this.commercialOfferData.organization,
                    phone: this.commercialOfferData.phone,
                    name: this.commercialOfferData.name,
                    email: this.commercialOfferData.email,
                    comment: this.commercialOfferData.comment,
                    total_price: this.summProductsPdw(this.summarizeResult),
                })
                .then((response) => {
                    this.commercial_offer_id = response.data.id;
                    this.commercial_offer_created_at = response.data.created_at;

                    this.commercial_offer_sended = true;

                    this.commercialOfferData.organization = null
                    this.commercialOfferData.name = null
                    this.commercialOfferData.phone = null
                    this.commercialOfferData.email = null
                    this.commercialOfferData.comment = null
                }).catch((error) => {
                    this.is_disable_commercial_offer_btn = false;
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        }
    }
};
</script>

<style scoped>
a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 25px 0 20px;
}
.service_header {
    display: flex;
    justify-content: space-between;
}
.service_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 651px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

#close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.add_item_modal {
    width: 92%;
}

.add_item_modal .modal_header {
    border-bottom: none;
}

.add_item_modal .modal_header_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

@media (max-width: 780px) {
    .container {
        padding: 50px 0 0 0;
    }
    .service_header {
        flex-direction: column;
    }
}

@media (max-width: 420px) {
    .modal {
        width: 385px;
    }
    .service_title {
        font-size: 27px;
        line-height: 36px;
    }
}

.top_bar {
    margin-top: 80px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.top_bar .top_bar_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.top_bar .add_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 251px;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
}

.main_table {
    width:100%;
    border-radius: 4px 4px 0px 0px;
}

.main_table, th, td {
  border: 1px solid #DEE2E6;
  border-collapse: collapse;
}

.main_table_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--body-text-body-color, #212529);
    height: 60px;
    background: #E3F1FF;
    overflow-wrap: break-word;
    padding: 5px;
}

.main_table_row {
    height: 53px;
}

.main_table_count_input {
    width: 60px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #DEE2E6;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}

.edit_row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 10px;
}

.total_btns {
    display: flex;
    gap: 26px;
}

.view_spec_btn {
    width: 264px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.view_spec_btn.disabled {
    background: #DEE2E6;
    color: #6C757D;
}

.download_spec {
    width: 323px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.download_spec.disabled {
    color: #6C757D;
}

.total_summ {
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    gap: 38px;
}

.subtitle {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
}

.form_row {
    display: flex;
    gap: 100px;
}

.input_group {
    display: flex;
    flex-direction: row;
    gap: 18px;
}

.form_input_item {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.form_input_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}

.form_input {
    width: 306px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 10px 16px;
}
.form_select {
    padding: 10px 30px;
    width: 306px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    display: flex;
    align-items: center;
}

.table_select {
    width: 100%;
    padding-left: 10px;
    padding-right: 30px;
    border: none;
    outline: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    cursor: pointer;
}

.form_border {
    border: 1px solid rgba(206, 212, 218, 0.4);
    border-radius: 4px;
    padding: 12px;
    margin-top: 20px;
}

.checkbox_input {
    padding: 0;
    margin: 0;
    margin-right: 9px;
}

.form_border .input_group {
    margin-top: 24px;
}

.line_table {
    margin-top: 30px;
}

.line_table select {
    padding-right: 40px;
}

.line_table thead th {
    height: 72px!important;
}

.line_table tbody tr {
    height: 55px!important;
}

.line_table table {
    table-layout:fixed;
}

.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}


table {
  margin: 0 auto;
}

/* Default Table Style */
table {
  color: #333;
  background: white;
  border: 1px solid grey;
  font-size: 12pt;
  border-collapse: collapse;
}
table thead th,
table tfoot th {
  text-align: start;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
table caption {
  padding:.5em;
}
table th,
table td {
    border: 1px solid #DEE2E6;
}

.delete_td {
    padding: 22px 10px 24px 20px;
}

.add_btn {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 16px;
}

.option_select {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    background-color: #FFFFFF;

    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    width: 100%;
}

.count_td {
    padding: 10px 22px 10px 0px;
}

.count_td .count span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
}

.count_td .count a {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
}

.count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
}

.count a {
    color: #000000;
}

.ol_num {
    width: 50px;
    text-align: center;
}

.ol_eq {
    width: 288px;
    max-width: 288px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_eq__select {
    width: 240px;
    max-width: 240px;
}

.ol_p_ctn {
    width: 217px;
    max-width: 217px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_p_ctn__select {
    width: 174px;
    max-width: 174px;
}

.ol_char {
    width: 205px;
    max-width: 205px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_char__select {
    width: 166px;
    max-width: 166px;
}

.ol_curr {
    width: 189px;
    max-width: 189px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_curr__select {
    width: 148px;
    max-width: 148px;
}

.ol_cnt {
    width: 128px;
    padding-left: 22px;
}

.ol_article {
    width: 172px;
    max-width: 172px;
    padding-left: 22px;
}

.ol_close {
    width: 46px;
    padding-left: 16px;
}

.summ_point {
    text-align: flex-end;
    padding-right: 22px;
}

.summ_value {
    text-align: center;
    padding-right: 22px;
}

.variation_table {
    padding-top: 70px;
}

.variation_table_footer {
    padding-left: 42px;
    padding-right: 42px;
    display: flex;
    justify-content: space-between;
}
.module_ctn_container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.module_ctn {
    display: flex;
    align-items: center;
    gap: 10px;
}
.module_ctn_title {
    margin: 0px;
    padding: 0px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}
.module_ctn_input {
    width: 86px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}
.btn_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
}
.border-danger {
    border: 1px solid red;
    color: red;
}
.error_text {
    color: red;
}
.modal_total {
    width: 90%;
    top: 435px;
    max-width: 1296px;
    height: 80vh;
    overflow: auto;
}

.modal_total .modal_content{
    overflow: auto;
    height: 470px;
    font-size: 14px;
    line-height: 21px;
    margin: 0px;
}
.modal_total .title{
    margin: 0px;
    padding: 0px;
    margin-bottom: 10px;
}

.modal_total table {
    table-layout: fixed;
    font-size: 14px;
    line-height: 21px;
}

.title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}

.bottom_row {
    display: flex;
    width: 100%;
    align-items: flex-end;
    padding-top: 40px;
}

.bottom_row_block {
    display: flex;
    width: 100%;
    align-items: flex-end;
    align-items: baseline;
}

.nominal_select {
    padding: 12px 16px;
    width: 200px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.metal_constr_select {
    width: 260px;
    padding-right: 40px;
}

.total_key {
    width: 22px;
    padding: 0;
    height: 38px;
    padding-right: 22px;
    text-align: center;
}
.total_title {
    width: 140px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_maker {
    width: 62px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_count {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_od {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_price {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_summ2 {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_tech {
    width: 30px;
    text-align: center;
    height: 38px;
}
.center {
    text-align: center;
    height: 38px;
}
.totat_tr {
    height: 38px;
}

.summ_text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.modal_bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
}

.modal_bottom_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
}

.modal_bottom__btns {
    display: flex;
    align-items: center;
    gap: 30px;
}

.form_radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.selected_value {
    margin-left: 18px;
    font-weight: 400;
    cursor: pointer;
}

.avr_summ_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.avr_excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.modal_total table th, .modal_total table td, .modal_total table {
    border: none;
}
.modal_total thead {
    border-bottom: 1.5px solid #356EEF;
}
.modal_total tr {
    border-bottom: 1px solid #C8E4FF;
}
.modal_total tr:hover {
    background-color: #F0F8FF;
}
.modal_total .modal_header {
    border-bottom: none;
}

.product_media_modal .modal_content {
    max-height: 70vh;
    margin-top: 0px;
}
.product_media_modal {
    padding: 0px;
    z-index: 10000!important;
}
.product_media_modal #close_modal{
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
}
.warning_popup #close_modal{
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
}

.warning_popup {
    z-index: 100000;
}

.warning_popup h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.warning_popup .confir_btn_group {
    display: flex;
    justify-content: left;
    gap: 15px;
    padding: 10px 0px;
}

.warning_popup .edit_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.warning_popup .confirm_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #FFFFFF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6C757D;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.block_images {
    display: flex;
    gap: 20px;
}

.sub_images {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 200px;
    overflow: auto;
}

.product_media_modal_sub_images {
    width: 100%;
    display: flex;
    gap: 17px;
    overflow: auto;
    padding: 5px 10px 0px 10px;
    margin-bottom: 10px;
}

.product_img {
    width: 55px;
    height: auto;
    cursor: pointer;
}

.product_media_modal_img {
    width: 48px;
    height: 48px;
    cursor: pointer;
}

.main_img_container {
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 180px;
}
.main_img_container svg {
    position: absolute;
    bottom: 8px;
    right: 8px;
    cursor: pointer;
}

.product_info_text {
    margin: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    margin-top: 10px;
}

.product-item.active {
    background-color: #C8E4FF;
}
.product_img.active {
    border: 1px solid #C8E4FF;
}
.product_media_modal_img.active {
    border: 1px solid #C8E4FF;
}
.product_video_iframe {
    pointer-events: none;
}

.product_media_modal_main_img {
    width: auto;
    height: auto;
    max-height: 250px;
}

.product_media_modal_description {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

.nominal_power, .row_item {
    width: 100%;
}

.product_media_modal_main_img_container {
    position: relative;
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    padding: 30px;
}
.product_media_modal_row {
    display: flex;
    gap: 10px;
}
.product_media_modal_main_img_container .group_btns {
    display: flex;
    gap: 30px;
    position: absolute;
    bottom: 20px;
    right: 20px;
}

.zindexed {
    z-index: 9999!important;
}

#addMoadal {
    max-height: 70vh;
}

.input-disabled {
    color: #6C757D!important;
}

.form_input_item_checkbox {
    display: flex;
}

.select_container {
    position: relative;
}

.select_container .clear_icon {
    position: absolute;
    top: 17px;
    right: 35px;
    cursor: pointer;
}

.form_input_title_row {
    display: flex;
    justify-content: space-between;
}

.accountings_type_file_link {
    font-size: 12px;
    color: #356EEF;
    text-decoration: underline;
}

.non_selected {
    color: #6C757D!important;
}

.add_item_modal .info_form {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

@media (max-width: 1120px) {
    .bottom_row {
        align-items: flex-start;
        flex-direction: column;
        gap: 40px;
    }
    .row_item, .bottom_row_block {
        width: auto;
    }
    .bottom_row_block {
        gap: 50px;
    }
}

@media (max-width: 960px) {
    .product_media_modal_main_img {
        width: 100%;
        height: auto;
        max-height: 100%;
    }
    .product_media_modal_row {
        flex-direction: column;
    }
    .total_key {
        width: 30px;
    }
    .total_title {
        padding-top: 15px;
        padding-bottom: 15px;
        width: 280px;
    }
    .total_maker {
        width: 125px;
    }
    .total_count {
        width: 90px;
    }
    .total_od {
        width: 90px;
    }
    .total_price {
        width: 90px;
    }
    .total_tech {
        width: 90px;
    }
    .add_item_modal .btn_container {
        justify-content: start;
    }
}

@media (max-width: 920px) {
    .main_table_container {
        width: 100%;
        overflow: auto;
    }
    .service_header {
        flex-direction: column;
    }
    .top_bar {
        flex-direction: column;
        justify-content: start;
        align-items: baseline;
    }
    .main_table_title {
        min-width: 120px;
    }

    .add_item_modal .input_group {
        flex-direction: column;
    }

    .add_item_modal .form_row {
        flex-direction: column;
        align-items: center;
    }

    .add_item_modal .info_form {
        width: 100%;
    }

    .add_item_modal .form_input {
        width: 100%;
    }

    .add_item_modal .form_input_item {
        width: 100%;
    }

    .add_item_modal .form_select {
        width: 100%;
    }

    .add_item_modal .line_table {
        overflow: auto;
    }

    .add_item_modal .line_table thead th {
        min-width: 120px;
    }
    .modal_total .modal_bottom {
        flex-direction: column;
        gap: 20px;
    }

    .notification_bar {
        right: 10px!important;
        padding: 20px 20px!important;
        font-size: 12px!important;
    }
}

@media (max-width: 680px) {
    .notification_bar {
        right: 5px!important;
        padding: 12px 20px!important;
        font-size: 12px!important;
        line-height: 84%!important;
        height: auto!important;
    }
    .notification_bar span {
        gap: 9px;
        flex-direction: column;
        text-align: center;
    }
    .total_btns {
        flex-direction: column;
        width: 100%;
    }
    .view_spec_btn, .download_spec, .metal_constr_select, .bottom_row_block {
        width: 100%;
    }
    .metal_constr_select {
        padding-right: 0px;
    }
    .bottom_row_block {
        flex-direction: column;
        gap: 20px;
    }
}

@media (max-width: 450px) {
    .modal_total {
        height: 655px;
        top: 350px;
    }
    .modal_total .modal_content {
        height: 355px;
    }
    .modal_total .modal_bottom__btns {
        flex-direction: column;
    }
    .modal_total .avr_summ_btn {
        width: 100%;
    }
    .modal_total .avr_excel_btn {
        width: 100%;
    }
}

@media (max-width: 400px) {
    .modal_total {
        height: 666px;
    }
}

@media (max-width: 390px) {
    .modal_total {
        width: 330px;
    }
}

@media only screen and (max-height: 740px) and (min-width: 1200px) {
    .modal_total {
        top: 360px;
    }
    .modal_total .modal_content {
        height: 370px;
    }
    .total_btns {
        justify-content: space-between;
        width: 100%;
    }
}

@media screen and (min-width: 1900px){
    .add_item_modal {
        width: auto;
    }
}

.notification_bar {
    width: auto;
    padding: 20px 25px;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 63px;
    right: 125px;
    border-radius: 4px;
    background: #6C99FF;
    box-shadow: -2px 4px 16px 0px rgba(0, 0, 0, 0.15);
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    z-index: 999;
}

.notification_bar.error {
    background: #ff5757;
}

.notification_bar.error svg path {
    fill: #FFFFFF;
}

.notification_bar span {
    display: flex;
    align-items: center;
    gap: 10px;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

tr.errors {
    border: 2px solid red;
}
.custom_select {
    position: relative;
}
.custom_select_dropdown {
    position: absolute;
    top: 33px;
    left: 0;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #CED4DA;
    background: #FFF;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.10);
    z-index: 2;
    padding: 0;
    width: 100%;
    max-height: 300px;
    overflow: auto;
}

.custom_select_dropdown li {
    list-style: none;
    border-top: 1px solid #CED4DA;
}

.custom_select_children:hover, .custom_select_row:hover {
    background: #E9F4FF;
    cursor: pointer;
}

.custom_select_children.active {
    background: #E9F4FF;
    cursor: pointer;
}

.custom_select_children input {
    display: none;
}

.custom_select_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 8px 8px 10px;
}

.custom_select_row input {
    display: none;
}

.custom_select_children {
    padding: 8px 8px 8px 25px;
    border-top: 1px solid #CED4DA;
}

.custom_select_childrens {
    padding: 0;
    display: flex;
    flex-direction: column;
}

.custom_select {
    cursor: pointer;
}

.d-none {
    display: none;
}

.select_item_btn {
    display: flex;
    width: 79px;
    height: 27px;
    padding: 3px 6px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: var(--Systemblue, #356EEF);
    color: var(--SystemWhite, #FFF);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

select:disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

input:disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

.commercial_offer_header {
    border-radius: 4px;
    background: rgba(200, 228, 255, 0.45);
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.commercial_offer_header_title {
    color: #1C1C1C;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.commercial_offer_drop_row {
    rotate: 180deg;
}
.commercial_offer_body {
    padding: 0px 16px 24px 16px;
    background: rgba(200, 228, 255, 0.45);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.customer_info .form_input {
    max-width: 100%;
}
.flex_form {
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}
.form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.error_text {
    color: red;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.textarea_container {
    position: relative;
}
.total_words {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: rgb(95,99,104);
    font-size: 14px;
}
.commercial_offer_body .form_textarea {
    resize: none;
    width: 100%;
}
.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
.block_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#close_offer {
    cursor: pointer;
}
.commercial_offer_order_title {
    color: #212529;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    margin: 0px;
}
.commercial_offer_order {
    margin-top: 24px;
    border-radius: 4px;
    border-left: 4px solid #356EEF;
    background: #FFF;
    padding: 16px;
}
.commercial_offer_order_text {
    margin-top: 12px;
}
@media (max-width: 1200px) {
    .customer_info {
        flex-direction: column;
    }
    .form_input {
        width: 100%!important;
    }
}
@media (max-width: 600px) {
    .flex-row {
        flex-direction: column!important;;
    }
    .commercial_offer_order_btn {
        width: 100%;
    }
}
@media (min-width: 1600px) {
    .modal_total {
        top: 40%;
        height: auto;
    }
}
</style>
